<template>
  <div class="doctor-rank" :class="{ bgfff: !isApp, pt50: isApp }">
    <div
      class="doctor-rank-item"
      v-for="(item, index) in rankList"
      :key="item.topNo + index"
    >
      <div
        class="doctor-rank-item-info"
        :class="{ active: userInfo.topNo == item.topNo }"
      >
        <i>{{ item.topNo }}</i>
        <div class="doctor-rank-item-border">
          <div
            class="doctor-rank-item-pic"
            :style="{ backgroundImage: 'url(' + item.userHeadImage + ')' }"
          ></div>
        </div>
        <span class="name font-28">{{ item.userName }}</span>
      </div>
      <div class="doctor-rank-item-times">
        <span class="font-28" v-if="item.studyTime">{{ item.studyTime }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.doctor-rank {
  padding-top: 0.28rem;
  padding-left: 0.29rem;
  padding-right: 0.43rem;
  padding-bottom: 2.56rem;
}
.doctor-rank-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 0.72rem;
  margin-bottom: 0.43rem;
  &:last-child {
    margin-bottom: 0;
  }
}
.doctor-rank-item-info {
  display: flex;
  align-items: center;
  i {
    text-align: center;
    width: 0.74rem;
    line-height: 0.3rem;
    margin-right: 0.07rem;
    font-family: DINEngschrift;
    font-size: 32px;
    color: 666;
  }
  .name {
    color: #232323;
    font-family: PingFangSC-Regular, PingFang SC;
    max-width: 300px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &.active {
    i {
      color: #6183f2;
    }
    .doctor-rank-item-border {
      padding: 0.04rem;
      border-radius: 50%;
      background: linear-gradient(
        180deg,
        rgba(154, 185, 250, 1),
        rgba(97, 131, 242, 1)
      );
    }
    .doctor-rank-item-pic {
      width: 100%;
      height: 100%;
      margin-right: 0;
    }
  }
}
.doctor-rank-item-times {
  color: #666;
  display: flex;
  align-items: center;
  height: 0.5rem;
  span {
    font-family: PingFangSC-Regular, PingFang SC;
    padding: 0 0.04rem;
    &.fs32 {
      font-size: 28px;
    }
  }
  span {
    margin-top: 0.06rem;
    &.fs28 {
      font-size: 28px;
    }
  }
}
.doctor-rank-item-border {
  width: 0.8rem;
  height: 0.8rem;
  margin-right: 0.18rem;
}
.doctor-rank-item-pic {
  width: 0.8rem;
  height: 0.8rem;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  background-repeat: no-repeat;
  margin-right: 0.16rem;
}
</style>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    rankList: {
      type: Array,
      default: () => []
    },
    userInfo: {
      type: Object,
      default: () => Object.create(null)
    },
    isApp: {
      type: Boolean,
      default: false
    }
  }
})
</script>
